import React, { useState, useRef, useEffect } from "react";
import { ChevronsUpDown, Check, Plus } from "lucide-react";

// Searchable, free-text-friendly combobox. options: array of strings.
export const VehicleCombobox = ({ value, onChange, onPick, options = [], placeholder, disabled, testid, icon: Icon }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const boxRef = useRef(null);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const q = query.trim().toLowerCase();
  const filtered = q ? options.filter((o) => o.toLowerCase().includes(q)) : options;
  const showFreeText = q && !options.some((o) => o.toLowerCase() === q);

  const choose = (val, isPick) => {
    onChange(val);
    if (isPick && onPick) onPick(val);
    setQuery("");
    setOpen(false);
  };

  return (
    <div className="relative" ref={boxRef} data-testid={testid}>
      <button
        type="button"
        disabled={disabled}
        data-testid={testid ? `${testid}-trigger` : undefined}
        onClick={() => !disabled && setOpen((o) => !o)}
        className={`w-full flex items-center gap-2 bg-black/50 border border-white/10 text-left px-3 py-2.5 rounded-sm text-sm focus:border-aurora-cyan focus:outline-none transition-colors ${disabled ? "opacity-40 cursor-not-allowed" : "hover:border-white/25"}`}
      >
        {Icon && <Icon className="w-4 h-4 text-zinc-500 shrink-0" />}
        <span className={`flex-1 truncate ${value ? "text-white" : "text-zinc-600"}`}>{value || placeholder}</span>
        <ChevronsUpDown className="w-4 h-4 text-zinc-500 shrink-0" />
      </button>

      {open && (
        <div className="absolute z-30 mt-1 w-full bg-ink-base border border-white/15 rounded-sm shadow-xl overflow-hidden">
          <input
            autoFocus
            data-testid={testid ? `${testid}-search` : undefined}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Rechercher ou saisir..."
            className="w-full bg-black/60 border-b border-white/10 px-3 py-2 text-sm text-white placeholder:text-zinc-600 focus:outline-none"
          />
          <div className="max-h-60 overflow-y-auto py-1">
            {filtered.map((o) => (
              <button
                key={o}
                type="button"
                data-testid={testid ? `${testid}-opt-${o}` : undefined}
                onClick={() => choose(o, true)}
                className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm hover:bg-aurora-cyan/10 transition-colors"
              >
                {value === o ? <Check className="w-3.5 h-3.5 text-aurora-cyan shrink-0" /> : <span className="w-3.5 shrink-0" />}
                <span className="truncate text-zinc-200">{o}</span>
              </button>
            ))}
            {showFreeText && (
              <button
                type="button"
                data-testid={testid ? `${testid}-freetext` : undefined}
                onClick={() => choose(query.trim(), false)}
                className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm hover:bg-aurora-purple/10 transition-colors border-t border-white/5"
              >
                <Plus className="w-3.5 h-3.5 text-aurora-purple shrink-0" />
                <span className="text-aurora-purple">Utiliser « {query.trim()} »</span>
              </button>
            )}
            {filtered.length === 0 && !showFreeText && (
              <div className="px-3 py-3 font-mono text-[11px] text-zinc-600">Aucun résultat</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
